import { CalendarPassThroughOptions } from 'primereact/calendar'
import { classNames } from 'primereact/utils'
import '../../assets/styles/primereact/Calendar.scss'

export const calendarConfig: CalendarPassThroughOptions = {
  // root: ({ props }: { props: any }) => ({
  //   className: classNames('inline-flex', 'w-auto', 'relative', {
  //     'opacity-60 select-none pointer-events-none cursor-default': props.disabled,
  //   }),
  // }),
  // input: ({ props }: { props: any }) => ({
  //   root: {
  //     className: classNames(
  //       'font-sans text-base text-gray-600 dark:text-white/80 bg-white dark:bg-gray-900 p-3 border border-gray-300 dark:border-blue-900/40 transition-colors duration-200 appearance-none',
  //       'hover:border-blue-500',
  //       {
  //         'rounded-lg': !props.showIcon,
  //         'border-r-0 rounded-l-lg': props.showIcon,
  //       },
  //     ),
  //   },
  // }),
  // dropdownButton: {
  //   root: ({ props }: { props: any }) => ({
  //     className: classNames({ 'rounded-l-none': props.icon }),
  //   }),
  // },
  // panel: ({ props }: { props: any }) => ({
  //   className: classNames('bg-white dark:bg-gray-900', 'min-w-full', {
  //     'shadow-md border-0 absolute': !props.inline,
  //     'inline-block': props.inline,
  //     'rounded-none': props.inline,
  //     'p-0': props.inline,
  //     'overflow-x-none': props.inline,
  //   }),
  // }),
  // header: {
  //   className: classNames('flex', 'items-center', 'justify-between', 'p-1', 'text-gray-700', 'dark:text-white/80 bg-white dark:bg-gray-900 font-semibold'),
  // },
  // previousButton: {
  //   root: {
  //     className: classNames(
  //       'flex items-center justify-center cursor-pointer overflow-hidden relative',
  //       'w-8 h-8 text-gray-600 dark:text-white/70 border-0 bg-transparent rounded-full transition-colors duration-200 ease-in-out',
  //       'hover:text-gray-700 dark:hover:text-white/80 hover:border-transparent hover:bg-gray-200 dark:hover:bg-gray-800/80 ',
  //     ),
  //   },
  // },
  // title: { className: 'leading-8 mx-auto' },
  // monthTitle: {
  //   className: classNames('text-gray-700 dark:text-white/80 transition duration-200 font-semibold p-2', 'hover:text-blue-500'),
  // },
  // yearTitle: {
  //   className: classNames('text-gray-700 dark:text-white/80 transition duration-200 font-semibold p-2', 'hover:text-blue-500'),
  // },
  // nextButton: {
  //   root: {
  //     className: classNames(
  //       'flex items-center justify-center cursor-pointer overflow-hidden relative',
  //       'w-8 h-8 text-gray-600 dark:text-white/70 border-0 bg-transparent rounded-full transition-colors duration-200 ease-in-out',
  //       'hover:text-gray-700 dark:hover:text-white/80 hover:border-transparent hover:bg-gray-200 dark:hover:bg-gray-800/80 ',
  //     ),
  //   },
  // },
  // table: {
  //   className: classNames('border-collapse', 'w-full', 'my-2'),
  // },
  // tableHeaderCell: { className: 'p-3' },
  // weekDay: { className: 'text-gray-600 dark:text-white/70' },
  // day: () => ({ className: classNames('p-0 m-0 w-10 h-10') }),
  // dayLabel: ({ context }: { context: any; props: any; state: any }) => ({
  //     className: classNames(
  //       'mk-calendar-day',
  //       'w-10 h-10',
  //       // 'rounded-full',
  //       'transition-shadow',
  //       'duration-200',
  //       'border-transparent',
  //       'border',
  //       'flex',
  //       'items-center',
  //       'justify-center',
  //       // 'mx-auto',
  //       'overflow-hidden',
  //       'relative',
  //       'focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[0_0_0_0.2rem_rgba(147,197,253,0.5)]',
  //       {
  //         'opacity-60 cursor-default': context.disabled,
  //         'cursor-pointer': !context.disabled,
  //       },
  //       {
  //         'text-gray-600 dark:text-white/70 bg-transparent hover:bg-gray-200 dark:hover:bg-gray-800/80': !context.selected && !context.disabled,
  //
  //         'text-white bg-[#e35e2b] hover:bg-[#d05525] dark:hover:bg-[#d05525]': context.selected && !context.disabled,
  //
  //         'text-gray-700 bg-gray-300 cursor-not-allowed': context.selected && context.disabled,
  //       },
  //     ),
  //   }),
  // monthPicker: { className: 'my-2' },
  // month: ({ context }: { context: any }) => ({
  //   className: classNames(
  //     'w-1/3 inline-flex items-center justify-center cursor-pointer overflow-hidden relative',
  //     'p-2 transition-shadow duration-200 rounded-lg',
  //     'focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[0_0_0_0.2rem_rgba(147,197,253,0.5)]',
  //     {
  //       'text-gray-600 dark:text-white/70 bg-transprent hover:bg-gray-200 dark:hover:bg-gray-800/80': !context.selected && !context.disabled,
  //       'text-blue-700 bg-blue-100 hover:bg-blue-200': context.selected && !context.disabled,
  //     },
  //   ),
  // }),
  // yearPicker: {
  //   className: classNames('my-2'),
  // },
  // year: ({ context }: { context: any }) => ({
  //   className: classNames(
  //     'w-1/2 inline-flex items-center justify-center cursor-pointer overflow-hidden relative',
  //     'p-2 transition-shadow duration-200 rounded-lg',
  //     'focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[0_0_0_0.2rem_rgba(147,197,253,0.5)]',
  //     {
  //       'text-gray-600 dark:text-white/70 bg-transprent hover:bg-gray-200 dark:hover:bg-gray-800/80': !context.selected && !context.disabled,
  //       'text-blue-700 bg-blue-100 hover:bg-blue-200': context.selected && !context.disabled,
  //     },
  //   ),
  // }),
  // separatorContainer: { className: 'flex items-center flex-col px-2' },
  // separator: { className: 'text-xl' },
  // incrementButton: {
  //   className: classNames(
  //     'flex items-center justify-center cursor-pointer overflow-hidden relative',
  //     'w-8 h-8 text-gray-600 dark:text-white/70 border-0 bg-transparent rounded-full transition-colors duration-200 ease-in-out',
  //     'hover:text-gray-700 dark:hover:text-white/80 hover:border-transparent hover:bg-gray-200 dark:hover:bg-gray-800/80 ',
  //   ),
  // },
  // decrementButton: {
  //   className: classNames(
  //     'flex items-center justify-center cursor-pointer overflow-hidden relative',
  //     'w-8 h-8 text-gray-600 dark:text-white/70 border-0 bg-transparent rounded-full transition-colors duration-200 ease-in-out',
  //     'hover:text-gray-700 dark:hover:text-white/80 hover:border-transparent hover:bg-gray-200 dark:hover:bg-gray-800/80 ',
  //   ),
  // },
  // groupContainer: { className: classNames('flex') },
  // group: {
  //   className: classNames('flex-1', 'px-4'),
  // },
  // transition: {
  //   timeout: 150,
  //   classNames: {
  //     enter: 'opacity-0 scale-75',
  //     enterActive: 'opacity-100 !scale-100 transition-transform transition-opacity duration-150 ease-in',
  //     exit: 'opacity-100',
  //     exitActive: '!opacity-0 transition-opacity duration-150 ease-linear',
  //   },
  // },
  root: ({ props }: { props: any }) => ({
    className: classNames('calendar', {
      'calendar--disabled': props.disabled,
    }),
  }),
  input: ({ props }: { props: any }) => ({
    root: {
      className: classNames('calendar__input', {
        'rounded-lg': !props.showIcon,
        'border-r-0 rounded-l-lg': props.showIcon,
      }),
    },
  }),
  dropdownButton: {
    root: ({ props }: { props: any }) => ({
      className: classNames({ 'rounded-l-none': props.icon }),
    }),
  },
  panel: ({ props }: { props: any }) => ({
    className: classNames('calendar__panel', {
      'calendar__panel--toggled': !props.inline,
      'calendar__panel--inline': props.inline,
    }),
  }),
  header: {
    className: classNames('calendar__header'),
  },
  previousButton: {
    className: classNames('calendar__header-button calendar__header-button--previous'),
  },
  title: { className: 'calendar__title subtitle-2' },
  monthTitle: {
    className: classNames('calendar__title-bit calendar__title-bit--month'),
  },
  yearTitle: {
    className: classNames('calendar__title-bit calendar__title-bit--year'),
  },
  nextButton: {
    className: classNames('calendar__header-button calendar__header-button--next'),
  },
  table: {
    className: classNames('calendar__table'),
  },
  tableHeaderCell: { className: 'calendar__table-cell' },
  day: { className: 'calendar__day' },
  weekday: { className: 'calendar__day calendar__day--weekday body-2' },
  dayLabel: ({ context }: { context: any }) => ({
    className: classNames(
      'calendar__day-label',
      {
        'calendar__day-label--disabled': context.disabled,
      },
      {
        'calendar__day-label--selected': context.selected && !context.disabled,
      },
    ),
  }),
  monthPicker: { className: 'calendar__picker calendar__picker--month' },
  yearPicker: { className: classNames('calendar__picker calendar__picker--year') },
  month: ({ context }: { context: any }) => ({
    className: classNames('calendar__month', {
      'calendar__month--selected': context.selected && !context.disabled,
    }),
  }),
  year: ({ context }: { context: any }) => ({
    className: classNames('calendar__year', {
      'calendar__year--selected': context.selected && !context.disabled,
    }),
  }),
  timePicker: { className: classNames('calendar__time-picker') },
  separatorContainer: { className: 'calendar__separator-container' },
  separator: { className: 'calendar__separator' },
  hourPicker: { className: 'calendar__time-picker-bit calendar__time-picker-bit--hour' },
  minutePicker: { className: 'calendar__time-picker-bit calendar__time-picker-bit--minute' },
  ampmPicker: { className: 'calendar__time-picker-bit calendar__time-picker-bit--ampm' },
  incrementButton: {
    className: classNames('calendar__time-picker-button calendar__time-picker-button--increment'),
  },
  decrementButton: {
    className: classNames('calendar__time-picker-button calendar__time-picker-button--decrement'),
  },
  groupContainer: { className: 'calendar__group-container' },
  group: {
    className: classNames('calendar__group'),
  },
  // transition: TRANSITIONS.overlay,
}
